import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { StudentInternshipDetailsModel } from "common/models/page-models/student-side/internship-detail/student-internship-detail-data.model";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { DataService } from "../../base-data-services/data.service";

@Injectable()
export class StudentFeedbackQuestionsDataService extends DataService<StudentInternshipDetailsModel> {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.studentFeedbackFormQuestion,http);
    }
 

    createInstance(): StudentInternshipDetailsModel {
        return new StudentInternshipDetailsModel();
    }

    
 
}